import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import methodModel from "../../../methods/methods";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import Sidebar from "../sidebar";
import { FiMenu, FiX } from "react-icons/fi";
import { LuLogOut, LuUser } from "react-icons/lu";
import { GoLock } from "react-icons/go";
import {
  MdOutlineChat,
  MdOutlineKeyboardDoubleArrowLeft,
} from "react-icons/md";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { IoSettingsOutline } from "react-icons/io5";
import { FiBell } from "react-icons/fi";
import ApiClient from "../../../methods/api/apiClient";
import socketModel from "../../../models/socketModel";
import { useDispatch, useSelector } from "react-redux";
import { count_success } from "../../../Pages/actions/count";
import { RiMenuFold4Line, RiMenuUnfold4Line } from "react-icons/ri";
// import { order_success } from "../../../Pages/actions/order";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Html = ({ isOpen, notificationTotal, toggle, user, isOpen1, Logout }) => {
  const [notificationData, setNotificationData] = useState([]);
  const [isOpenNotification, setIsOpenNotification] = useState(false);
  const dispatch = useDispatch();
  const history = useNavigate();
  const [hasNewMessage, setHasNewMessage] = useState(false);
  // const [unReadCount, setUnReadCount] = useState(0)
  const unReadCount = useSelector((state) => state?.count?.data)
  console.log(unReadCount, "unReadCount")
  const handleToggleNotification = () => {
    setIsOpenNotification(!isOpenNotification);
    setShowSuggestions(true);
    // managerId: user._id
  };

  const getNotifications = () => {
    ApiClient.get(
      `dash/shift/notification?status=unread&managerId=${user._id}`
    ).then((res) => {
      if (res.success) {
        setNotificationData(res.data);
      }
    });
  };
  useEffect(()=>{
       const location = window.location.pathname;
       const userPermissions= user?.permissions?.[0] || {};
       const routePermissionMap ={
        "/dashboard":"readDashboard",
        "/shift": "readShift",
      "/staff": "readStaff",
      "/attendance": "readattendance",
      "/budget": "readbudget",
      "/chats": "readchats",
      "/dailyreport": "readdailyreport",
      "/performance": "readperformance",
      "/setting": "readsetting",
       }
       const basePath =`/${location.split("/")[1]}`;
       const requiredPermission= routePermissionMap[basePath];
       if(requiredPermission && !userPermissions[requiredPermission]) {
         history("/profile");
       }
},[user,history]);

  // useEffect(() => {
  //   window.googleTranslateElementInit = () => {
  //     console.log("Callback: googleTranslateElementInit");
  //     try {
  //       new window.google.translate.TranslateElement(
  //         {
  //           pageLanguage: "en",
  //           includedLanguages: "en,ja",
  //         },
  //         "google_translate_element"
  //       );
  //       setTimeout(() => {
  //         const select = document.querySelector(".goog-te-combo");
  //         if (select) {
  //           select.value = "en";
  //           select.dispatchEvent(new Event("change"));
  //           console.log("Defaulted to English");
  //         }
  //       }, 1000);
  //     } catch (e) {
  //       console.error("Translate Element failed to initialize", e);
  //     }
  //   };
  //   if (!document.getElementById("google_translate_script")) {
  //     const script = document.createElement("script");
  //     script.id = "google_translate_script";
  //     script.src =
  //       "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
  //     script.async = true;
  //     document.body.appendChild(script);
  //   }
  // }, []);
  useEffect(() => {
    const loadGoogleTranslateScript = () => {
      if (!document.getElementById("google_translate_script")) {
        const addScript = document.createElement("script");
        addScript.id = "google_translate_script";
        addScript.type = "text/javascript";
        addScript.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";

        addScript.onerror = (err) => {
          console.error("Google Translate script failed to load", err);
        };

        document.body.appendChild(addScript);
      }

      window.googleTranslateElementInit = () => {
        try {
          new window.google.translate.TranslateElement(
            { pageLanguage: "en", includedLanguages: "en,ja" },
            "google_translate_element"
          );
        } catch (e) {
          console.error("Translate Element failed to initialize", e);
        }
      };
    };

    const elementContainer = document.getElementById("google_translate_element");
    if (!elementContainer || elementContainer.innerHTML.trim() === "") {
      loadGoogleTranslateScript();
    }
    socketModel.emit("user-online", { UserId: user?._id || user?.id });
    socketModel.emit("unread-count", { senderId: user?._id || user?.id })
    socketModel.on("unread-count-received", (response => {
      dispatch(count_success(response?.unreadCount));
    }))
  }, []);
  

  useEffect(() => {
    getNotifications();
    socketModel.on("new-order", (data) => {
      console.log(data, "0-0--0-0-0-00-0-00-0-");
      // dispatch(order_success(data.getNotification?.data));
      if (data.getNotification?.managerId == user._id) {
        setNotificationData(data.getNotification?.totalNotification);
        getNotifications();
      }
    });
  }, []);


  const viewNotification = (id, removeId) => {
    let payload = {
      id: removeId,
      status: "read",
    };
    ApiClient.put("dash/update/status", payload).then((res) => {
      if (res.success) {
        setIsOpenNotification(false);
        getNotifications();
        // Navigate to the order detail page
        history(`/shift`);
      }
    });
  };
  const [showSuggestions, setShowSuggestions] = useState(false);
  const suggestionsRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionsRef.current &&
        !suggestionsRef.current.contains(event.target)
      ) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  return (
    <nav
      component="header"
      className={`${isOpen ? "min-sidebar w-[calc(100%-80px)]" : "w-[calc(100%-220px)] "
        } shadow-btn py-1.5 bg-[#fff] border-0  fixed transition-[width] duration-300 ml-auto right-0 z-10 flex items-center !px-2 sm:!px-5`}
    >
      <div id="logoutBtn" onClick={() => Logout()}></div>
      <button
        onClick={toggle}
        className="h-[24px] w-[24px] p-1 bg-[#3C73AA]  flex items-center justify-center rounded-full absolute left-[-12px] right-left-arrow "
      >
        {!isOpen ? (
          <RiMenuUnfold4Line className="w-full h-full text-white"/>

        ) : (
          <RiMenuFold4Line className="w-full h-full text-white" />

        )}
      </button>
      {/* <p className="text-[14px] text-[#3C73AA] font-[700] hidden md:block ">
        Welcome Back, {user.fullName}
      </p> */}
      <div className="flex items-center ml-auto">
        <div id="google_translate_element" className=""></div>
        <div className="flex items-center sm:ml-2">
          {user.role == "manager" && (
            <div
              className="bg-[#F3F6F9] h-[30px] w-[30px] rounded-md flex items-center justify-center mr-3 relative cursor-pointer"
              onClick={() => history("/chats")}
            >
              {unReadCount > 0 && (
                <span className="bg-[#3C73AA] flex items-center justify-center h-[15px] w-[15px] rounded-full text-white text-[8px] absolute top-[-6px] right-[-4px] leading-[0px]">
                </span>
              )}
              <MdOutlineChat className="text-[#67748E]" />
            </div>


          )}
          {user.role == "manager" && (
            <div
              className="bg-[#F3F6F9] h-[30px] w-[30px] rounded-md flex items-center justify-center mr-3 relative cursor-pointer"
              onClick={handleToggleNotification}
            >
              <span className="bg-[#3C73AA] flex items-center justify-center h-[15px] w-[15px] rounded-full text-white text-[8px] absolute top-[-6px] right-[-4px] leading-[0px]">
                {notificationTotal}
              </span>
              <FiBell className="text-[#67748E]" />
            </div>
          )}
          {/* <div className="bg-[#F3F6F9] h-[30px] w-[30px] rounded-md flex items-center justify-center mr-2 sm:mr-4 cursor-pointer">
            <IoSettingsOutline className="text-[#67748E]" />
          </div> */}
        </div>
        <Menu as="div" className="relative">
          <div>
            <Menu.Button className="inline-flex w-full justify-center rounded-md bg-white py-1 text-sm font-semibold text-gray-900 ">
              <div className="flex items-center">
                <div className="flex items-center">
                  <img
                    alt="image"
                    src={methodModel.userImg(user.image)}
                    className="h-[30px] w-[30px] rounded-md border-[#DBE0E6] border-[1px] object-cover"
                  />
                  <div className="ml-1 text-left hidden sm:block">
                    <span className="capitalize  text-[#1B2950] font-[600]">
                      {user.fullName}
                    </span>
                    <p className="grayCls capitalize mb-0 text-capitalize text-[#67748E] font-[600]">
                      {user.role}
                    </p>
                  </div>
                </div>
                <i
                  className="fa fa-angle-down top-1 relative h-5 w-5 text-[#1B2950]"
                  aria-hidden="true"
                />
              </div>
            </Menu.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="py-1">
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to="/profile"
                      className={classNames(
                        active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                        "block px-4 py-2 text-sm flex items-center gap-2"
                      )}
                    >
                      <LuUser /> Profile
                    </Link>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to="/profile/change-password"
                      className={classNames(
                        active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                        "block px-4 py-2 text-sm flex items-center gap-2"
                      )}
                    >
                      <GoLock />
                      Change Password
                    </Link>
                  )}
                </Menu.Item>

                <Menu.Item className="divide-y-1 divide-gray-800 pt-1  mt-2">
                  <p className="border-t"></p>
                </Menu.Item>

                <Menu.Item className="">
                  {({ active }) => (
                    <span
                      onClick={() => Logout()}
                      className={classNames(
                        active ? "bg-gray-100 text-gray-900 " : "text-gray-700",
                        "block w-full px-4 py-2 text-left text-sm ancortag flex items-center gap-2 cursor-pointer"
                      )}
                    >
                      <LuLogOut />
                      Logout
                    </span>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
      {isOpen1 ? (
        <div className="w-100 mobi-dropdown">
          <Sidebar />
        </div>
      ) : (
        <></>
      )}
      {isOpenNotification && showSuggestions && (
        <div
          ref={suggestionsRef}
          className="absolute top-[62px] right-[12px] z-50 w-64 bg-white shadow-lg rounded-md border-[1px] border-[#4d8992]"
        >
          <p className="p-[10px] bg-[#3C73AA] text-white text-[14px] rounded-t-[4px]">
            Notifications
          </p>
          <div className="py-2 px-1 max-h-[350px] overflow-auto">
            {notificationData.length > 0 ? (
              notificationData.map((itm) => (
                <div
                  key={itm._id}
                  onClick={() => viewNotification(itm.orderId, itm._id)}
                  className="flex gap-1 mb-1 items-center cursor-pointer hover:bg-gray-100 p-2 border-b-[1px] border-gray-200"
                >
                  <div className="relative">
                    <img
                      src={methodModel.noImg(itm?.addedByDetails?.image)}
                      className="zoom_img min-w-[25px] w-[25px] min-h-[25px] h-[25px] object-cover cursor-pointer rounded-full "
                      alt="NO Image"
                    />
                  </div>
                  <p className="text-gray-700 text-[12px] leading-[14px]">
                    {itm?.addedByDetails?.fullName} Requested a shift request{" "}
                  </p>
                  <p></p>
                </div>
              ))
            ) : (
              <p className="text-xs text-slate-500 text-center">
                No notifications
              </p>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Html;
